const CATEGORIES = 'filters/CATEGORIES';
const SUB_CATEGORIES = 'filters/SUB_CATEGORIES';
const SEARCH = 'filters/SEARCH';
const PUBLISHED_DATES = 'filters/PUBLISHED_DATES';
const MUNICIPALITY = 'filters/MUNICIPALITY';
const SORT = 'filters/SORT';
const DOCUMENT_TYPES = 'filters/DOCUMENT_TYPES';
const DOCUMENT_SOURCES = 'filters/DOCUMENT_SOURCES';
const TABLE_ORDER = 'filters/TABLE_ORDER';
const PAGE_NUMBER = 'filters/PAGE_NUMBER';
const SET_LANGUAGE = 'filters/SET_LANGUAGE';


export default {
  CATEGORIES,
  SUB_CATEGORIES,
  SEARCH,
  PUBLISHED_DATES,
  MUNICIPALITY,
  DOCUMENT_TYPES,
  DOCUMENT_SOURCES,
  SORT,
  PAGE_NUMBER,
  TABLE_ORDER,
  SET_LANGUAGE
};



// WEBPACK FOOTER //
// ./src/filters/types.js